import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
/**
 * - Clase para leer los headers que regresan los servicios
 * - Estos header son regresados solo por algunos servicios
 * --- Fecha
 * --- Token para las llamadas a API Conect
 * - Los header son guardados en el storage
 *
 * @author: Isaac Salgado @iiSalgado
 * @version: 13/09/2018
 *
 */
@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  /**
   * Referencias a servicios
   */
  constructor() {}

    /**
     * - Se leen los header y solo se detecta si vienen los requeridos para los servicios
     * --- Fecha (para pantallas de resúmen)
     * --- Token para llamas a API Conect
     *
     * @param req HttpRequest
     * @param next HttpHandler
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const request = req.clone();
        return next.handle(request);
    }

   
}
